import { combineReducers } from "redux";

import Auth from "./auth/reducer";
import Layout from "./layout/reducer";
import MyAccount from "./My-Account/reducer";
import Dashboard from "./dashboard/reducer";
import Packages from "./packages/reducer";
import Activities from "./activities-list/reducer";

const rootReducer = combineReducers({
  Auth,
  Layout,
  MyAccount,
  Dashboard,
  Packages,
  Activities,
});

export default rootReducer;
